(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-serialization-kotlinx-serialization-json.js', './curity-ssi-libs-core.js', './kotlinx-serialization-kotlinx-serialization-core.js', './Kotlin-DateTime-library-kotlinx-datetime.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-serialization-kotlinx-serialization-json.js'), require('./curity-ssi-libs-core.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./Kotlin-DateTime-library-kotlinx-datetime.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-core-json'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'curity-ssi-libs-core-json'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-core-json'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'curity-ssi-libs-core-json'.");
    }
    if (typeof this['curity-ssi-libs-core'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-core-json'. Its dependency 'curity-ssi-libs-core' was not found. Please, check whether 'curity-ssi-libs-core' is loaded prior to 'curity-ssi-libs-core-json'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-core-json'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'curity-ssi-libs-core-json'.");
    }
    if (typeof this['Kotlin-DateTime-library-kotlinx-datetime'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-core-json'. Its dependency 'Kotlin-DateTime-library-kotlinx-datetime' was not found. Please, check whether 'Kotlin-DateTime-library-kotlinx-datetime' is loaded prior to 'curity-ssi-libs-core-json'.");
    }
    root['curity-ssi-libs-core-json'] = factory(typeof this['curity-ssi-libs-core-json'] === 'undefined' ? {} : this['curity-ssi-libs-core-json'], this['kotlin-kotlin-stdlib'], this['kotlinx-serialization-kotlinx-serialization-json'], this['curity-ssi-libs-core'], this['kotlinx-serialization-kotlinx-serialization-core'], this['Kotlin-DateTime-library-kotlinx-datetime']);
  }
}(globalThis, function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_io_curity_ssi_core, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_org_jetbrains_kotlinx_kotlinx_datetime) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.kb;
  var JsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.i;
  var Dictionary = kotlin_io_curity_ssi_core.$_$.e;
  var initMetadataForInterface = kotlin_kotlin.$_$.ma;
  var VOID = kotlin_kotlin.$_$.f;
  var toString = kotlin_kotlin.$_$.ob;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.y1;
  var JsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.m;
  var initMetadataForObject = kotlin_kotlin.$_$.oa;
  var toMap = kotlin_kotlin.$_$.m8;
  var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
  var hashCode = kotlin_kotlin.$_$.ha;
  var THROW_CCE = kotlin_kotlin.$_$.te;
  var equals = kotlin_kotlin.$_$.ba;
  var initMetadataForClass = kotlin_kotlin.$_$.ia;
  var JsonPrimitive_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.j;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.a6;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.m;
  var Unit_instance = kotlin_kotlin.$_$.h5;
  var JsonArray = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.f;
  var Default_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var emptyList = kotlin_kotlin.$_$.r6;
  var objectCreate = kotlin_kotlin.$_$.jb;
  var first = kotlin_kotlin.$_$.y6;
  var drop = kotlin_kotlin.$_$.q6;
  var toList = kotlin_kotlin.$_$.k8;
  var DefaultMultiValue = kotlin_io_curity_ssi_core.$_$.h;
  var toString_0 = kotlin_kotlin.$_$.vf;
  var get_all = kotlin_io_curity_ssi_core.$_$.i;
  var isSingleItem = kotlin_io_curity_ssi_core.$_$.k;
  var forEach = kotlin_io_curity_ssi_core.$_$.j;
  var MultiValue = kotlin_io_curity_ssi_core.$_$.l;
  var JsonPrimitive_1 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.k;
  var toMutableMap = kotlin_kotlin.$_$.p8;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.w;
  var lazy = kotlin_kotlin.$_$.qf;
  var getStringHashCode = kotlin_kotlin.$_$.ga;
  var toMap_0 = kotlin_io_curity_ssi_core.$_$.d;
  var JsonPrimitive_2 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.l;
  var ToString = kotlin_io_curity_ssi_core.$_$.m;
  var KProperty1 = kotlin_kotlin.$_$.ac;
  var getPropertyCallableRef = kotlin_kotlin.$_$.fa;
  var JsonNull_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.d;
  var asSequence = kotlin_kotlin.$_$.y5;
  var map = kotlin_kotlin.$_$.ec;
  var toList_0 = kotlin_kotlin.$_$.fc;
  var checkIndexOverflow = kotlin_kotlin.$_$.z5;
  var get_longOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.u;
  var toSet = kotlin_kotlin.$_$.gc;
  var get_booleanOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.o;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.t1;
  var Companion_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_datetime.$_$.c;
  var Exception = kotlin_kotlin.$_$.ke;
  var Companion_instance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.b;
  var isInterface = kotlin_kotlin.$_$.xa;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
  var StringCompanionObject_instance = kotlin_kotlin.$_$.w4;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u;
  var MapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.y4;
  var arrayOf = kotlin_kotlin.$_$.hf;
  var createKType = kotlin_kotlin.$_$.b;
  var serializer_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t2;
  var JsonElement = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.h;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.n;
  var iterator = kotlin_kotlin.$_$.cb;
  var isNumber = kotlin_kotlin.$_$.za;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.rf;
  var get_intOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.r;
  var get_floatOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.q;
  var get_doubleOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.p;
  //endregion
  //region block: pre-declaration
  initMetadataForInterface(ToJson, 'ToJson');
  function get_keys() {
    return this.y26().f2();
  }
  function get(key) {
    return this.y26().vl(key);
  }
  function toJson() {
    return new JsonObject(this.xl());
  }
  initMetadataForInterface(ToJsonDictionary, 'ToJsonDictionary', VOID, VOID, [Dictionary, ToJson], VOID, VOID, {0: ToJsonDictionarySerializer_getInstance});
  initMetadataForObject(FromJsonHelper, 'FromJsonHelper');
  initMetadataForCompanion(Companion);
  initMetadataForClass(JsonDictionary, 'JsonDictionary', VOID, VOID, [ToJsonDictionary], VOID, VOID, {0: JsonDictionarySerializer_getInstance});
  initMetadataForCompanion(Companion_0, VOID, [SerializerFactory]);
  initMetadataForClass(DefaultJsonMultiValue, 'DefaultJsonMultiValue', VOID, VOID, [MultiValue], VOID, VOID, {0: DefaultJsonMultiValueSerializer_getInstance});
  initMetadataForClass(CompositeFromJson, 'CompositeFromJson');
  initMetadataForClass(TypedDictionaryFromJson, 'TypedDictionaryFromJson');
  initMetadataForClass(TypedJsonDictionary, 'TypedJsonDictionary', VOID, VOID, [ToJsonDictionary]);
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(AnyString, 'AnyString', VOID, VOID, [ToString, ToJson], VOID, VOID, {0: AnyStringSerializer_getInstance});
  initMetadataForClass(JsonSerializer, 'JsonSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(DerivedSerializer, 'DerivedSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(DelegateSerializer, 'DelegateSerializer', VOID, DerivedSerializer);
  initMetadataForObject(ToJsonDictionarySerializer, 'ToJsonDictionarySerializer', VOID, DelegateSerializer);
  initMetadataForObject(JsonDictionarySerializer, 'JsonDictionarySerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(DefaultJsonMultiValueSerializer, 'DefaultJsonMultiValueSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(AnyStringSerializer, 'AnyStringSerializer', VOID, JsonSerializer);
  initMetadataForObject(JsToJsonConverter, 'JsToJsonConverter');
  initMetadataForObject(JsonToJsConverter, 'JsonToJsConverter');
  //endregion
  function ToJsonDictionary() {
  }
  function FromJsonHelper() {
  }
  protoOf(FromJsonHelper).b27 = function (json, type) {
    if (json instanceof JsonObject)
      return json;
    // Inline function 'kotlin.error' call
    var message = "Cannot deserialize '" + type + "', not an object";
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(FromJsonHelper).c27 = function (json, type) {
    var tmp;
    if (json instanceof JsonPrimitive) {
      tmp = json.d1b();
    } else {
      tmp = false;
    }
    if (tmp)
      return json;
    // Inline function 'kotlin.error' call
    var message = "Cannot deserialize '" + type + "', not a String";
    throw IllegalStateException_init_$Create$(toString(message));
  };
  var FromJsonHelper_instance;
  function FromJsonHelper_getInstance() {
    return FromJsonHelper_instance;
  }
  function Companion() {
  }
  protoOf(Companion).d27 = function (json) {
    return new JsonDictionary(toMap(FromJsonHelper_instance.b27(json, 'JsonDictionary')));
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function JsonDictionary(_claims) {
    this.z26_1 = _claims;
  }
  protoOf(JsonDictionary).f2 = function () {
    return this.z26_1.f2();
  };
  protoOf(JsonDictionary).vl = function (key) {
    return this.z26_1.e2(key);
  };
  protoOf(JsonDictionary).xl = function () {
    return this.z26_1;
  };
  protoOf(JsonDictionary).y26 = function () {
    return this;
  };
  protoOf(JsonDictionary).toString = function () {
    return 'JsonDictionary(_claims=' + toString(this.z26_1) + ')';
  };
  protoOf(JsonDictionary).hashCode = function () {
    return hashCode(this.z26_1);
  };
  protoOf(JsonDictionary).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonDictionary))
      return false;
    var tmp0_other_with_cast = other instanceof JsonDictionary ? other : THROW_CCE();
    if (!equals(this.z26_1, tmp0_other_with_cast.z26_1))
      return false;
    return true;
  };
  function toJson_0(_this__u8e3s4) {
    return JsonPrimitive_0(_this__u8e3s4);
  }
  function toJson_1(_this__u8e3s4) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(_this__u8e3s4, 10));
    var tmp0_iterator = _this__u8e3s4.j();
    while (tmp0_iterator.k()) {
      var item = tmp0_iterator.l();
      // Inline function 'io.curity.ssi.json.data.toJson.<anonymous>' call
      var tmp$ret$0 = toJson_0(item);
      destination.e(tmp$ret$0);
    }
    return new JsonArray(destination);
  }
  function Companion_0() {
  }
  protoOf(Companion_0).e27 = function (json, serializer) {
    var tmp;
    if (json instanceof JsonArray) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(json, 10));
      var tmp0_iterator = json.j();
      while (tmp0_iterator.k()) {
        var item = tmp0_iterator.l();
        // Inline function 'io.curity.ssi.json.data.Companion.fromJson.<anonymous>' call
        var tmp$ret$0 = Default_getInstance().b19(serializer, item);
        destination.e(tmp$ret$0);
      }
      tmp = DefaultJsonMultiValue_init_$Create$_0(destination);
    } else {
      tmp = DefaultJsonMultiValue_init_$Create$(Default_getInstance().b19(serializer, json));
    }
    return tmp;
  };
  protoOf(Companion_0).f27 = function (typeSerial0) {
    return DefaultJsonMultiValueSerializer_getInstance();
  };
  protoOf(Companion_0).wz = function (typeParamsSerializers) {
    return this.f27(typeParamsSerializers[0]);
  };
  var Companion_instance_1;
  function Companion_getInstance_1() {
    return Companion_instance_1;
  }
  function DefaultJsonMultiValue_init_$Init$(singleItem, $this) {
    DefaultJsonMultiValue.call($this, singleItem, emptyList());
    return $this;
  }
  function DefaultJsonMultiValue_init_$Create$(singleItem) {
    return DefaultJsonMultiValue_init_$Init$(singleItem, objectCreate(protoOf(DefaultJsonMultiValue)));
  }
  function DefaultJsonMultiValue_init_$Init$_0(many, $this) {
    DefaultJsonMultiValue.call($this, first(many), toList(drop(many, 1)));
    return $this;
  }
  function DefaultJsonMultiValue_init_$Create$_0(many) {
    return DefaultJsonMultiValue_init_$Init$_0(many, objectCreate(protoOf(DefaultJsonMultiValue)));
  }
  function DefaultJsonMultiValue(_first, _rest) {
    this.g27_1 = _first;
    this.h27_1 = _rest;
    this.i27_1 = this.g27_1;
    this.j27_1 = this.h27_1;
  }
  protoOf(DefaultJsonMultiValue).mm = function () {
    return this.i27_1;
  };
  protoOf(DefaultJsonMultiValue).lm = function () {
    return this.j27_1;
  };
  protoOf(DefaultJsonMultiValue).k27 = function (mapper) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.qm();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.j();
    while (tmp0_iterator.k()) {
      var item = tmp0_iterator.l();
      destination.e(mapper(item));
    }
    return new DefaultMultiValue(destination);
  };
  protoOf(DefaultJsonMultiValue).l27 = function (valueMapper) {
    var tmp;
    if (this.sm()) {
      tmp = valueMapper(this.i27_1);
    } else {
      // Inline function 'kotlin.collections.map' call
      var this_0 = this.qm();
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.j();
      while (tmp0_iterator.k()) {
        var item = tmp0_iterator.l();
        // Inline function 'io.curity.ssi.json.data.DefaultJsonMultiValue.toJson.<anonymous>' call
        var tmp$ret$0 = valueMapper(item);
        destination.e(tmp$ret$0);
      }
      tmp = new JsonArray(destination);
    }
    return tmp;
  };
  protoOf(DefaultJsonMultiValue).toString = function () {
    return 'DefaultJsonMultiValue(_first=' + toString_0(this.g27_1) + ', _rest=' + toString(this.h27_1) + ')';
  };
  protoOf(DefaultJsonMultiValue).hashCode = function () {
    var result = this.g27_1 == null ? 0 : hashCode(this.g27_1);
    result = imul(result, 31) + hashCode(this.h27_1) | 0;
    return result;
  };
  protoOf(DefaultJsonMultiValue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DefaultJsonMultiValue))
      return false;
    var tmp0_other_with_cast = other instanceof DefaultJsonMultiValue ? other : THROW_CCE();
    if (!equals(this.g27_1, tmp0_other_with_cast.g27_1))
      return false;
    if (!equals(this.h27_1, tmp0_other_with_cast.h27_1))
      return false;
    return true;
  };
  function toJson_2(_this__u8e3s4) {
    return JsonPrimitive_1(_this__u8e3s4);
  }
  function CompositeFromJson(_fromJson) {
    this.m27_1 = _fromJson;
  }
  protoOf(CompositeFromJson).d27 = function (json) {
    var serialized = this.m27_1.d27(json);
    return this.n27(serialized);
  };
  function TypedDictionaryFromJson(_typeKey) {
    this.o27_1 = _typeKey;
  }
  protoOf(TypedDictionaryFromJson).d27 = function (json) {
    var map = toMutableMap(FromJsonHelper_instance.b27(json, 'TypedJsonDictionary'));
    var type = unwrapString(map, this.o27_1);
    return new TypedJsonDictionary(this.o27_1, type, map.s() ? null : new JsonDictionary(map));
  };
  protoOf(TypedDictionaryFromJson).p27 = function (type, customClaims) {
    // Inline function 'kotlin.collections.buildMap' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.buildMapInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.curity.ssi.json.data.TypedDictionaryFromJson.toJson.<anonymous>' call
    if (!(customClaims == null)) {
      this_0.o2(customClaims.xl());
    }
    this_0.m2(this.o27_1, JsonPrimitive_0(type));
    var tmp$ret$2 = this_0.r8();
    return new JsonDictionary(tmp$ret$2);
  };
  function _get__serializable__azf9o3($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.t27_1;
    _serializable$factory();
    return this_0.b1();
  }
  function TypedJsonDictionary$_serializable$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.buildMap' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildMapInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.json.data.TypedJsonDictionary._serializable$delegate.<anonymous>.<anonymous>' call
      if (!(this$0.s27_1 == null)) {
        this_0.o2(this$0.s27_1.xl());
      }
      this_0.m2(this$0.q27_1, JsonPrimitive_0(this$0.r27_1));
      var tmp$ret$2 = this_0.r8();
      return new JsonDictionary(tmp$ret$2);
    };
  }
  function TypedJsonDictionary(typeKey, type, customClaims) {
    customClaims = customClaims === VOID ? null : customClaims;
    this.q27_1 = typeKey;
    this.r27_1 = type;
    this.s27_1 = customClaims;
    var tmp = this;
    tmp.t27_1 = lazy(TypedJsonDictionary$_serializable$delegate$lambda(this));
  }
  protoOf(TypedJsonDictionary).y26 = function () {
    return _get__serializable__azf9o3(this);
  };
  protoOf(TypedJsonDictionary).toString = function () {
    return 'TypedJsonDictionary(typeKey=' + this.q27_1 + ', type=' + this.r27_1 + ', customClaims=' + toString_0(this.s27_1) + ')';
  };
  protoOf(TypedJsonDictionary).hashCode = function () {
    var result = getStringHashCode(this.q27_1);
    result = imul(result, 31) + getStringHashCode(this.r27_1) | 0;
    result = imul(result, 31) + (this.s27_1 == null ? 0 : this.s27_1.hashCode()) | 0;
    return result;
  };
  protoOf(TypedJsonDictionary).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TypedJsonDictionary))
      return false;
    var tmp0_other_with_cast = other instanceof TypedJsonDictionary ? other : THROW_CCE();
    if (!(this.q27_1 === tmp0_other_with_cast.q27_1))
      return false;
    if (!(this.r27_1 === tmp0_other_with_cast.r27_1))
      return false;
    if (!equals(this.s27_1, tmp0_other_with_cast.s27_1))
      return false;
    return true;
  };
  function ToJson() {
  }
  function toJson_3(_this__u8e3s4) {
    var tmp = DefaultJsonMultiValue_init_$Create$_0(_this__u8e3s4.qm());
    return tmp.l27(toJson$lambda);
  }
  function toJson_4(_this__u8e3s4) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(_this__u8e3s4, 10));
    var tmp0_iterator = _this__u8e3s4.j();
    while (tmp0_iterator.k()) {
      var item = tmp0_iterator.l();
      // Inline function 'io.curity.ssi.json.data.toJson.<anonymous>' call
      var tmp$ret$0 = toJson_0(item);
      destination.e(tmp$ret$0);
    }
    return new JsonArray(destination);
  }
  function toJsons(_this__u8e3s4) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(_this__u8e3s4, 10));
    var tmp0_iterator = _this__u8e3s4.j();
    while (tmp0_iterator.k()) {
      var item = tmp0_iterator.l();
      // Inline function 'io.curity.ssi.json.data.toJsons.<anonymous>' call
      var tmp$ret$0 = item.a27();
      destination.e(tmp$ret$0);
    }
    return new JsonArray(destination);
  }
  function toJson_5(_this__u8e3s4) {
    return JsonPrimitive_2(_this__u8e3s4);
  }
  function Companion_1() {
  }
  protoOf(Companion_1).d27 = function (json) {
    return new AnyString(FromJsonHelper_instance.c27(json, 'AnyString').toString());
  };
  var Companion_instance_2;
  function Companion_getInstance_2() {
    return Companion_instance_2;
  }
  function AnyString(value) {
    this.u27_1 = value;
  }
  protoOf(AnyString).a27 = function () {
    return JsonPrimitive_0(this.u27_1);
  };
  protoOf(AnyString).toString = function () {
    return this.u27_1;
  };
  protoOf(AnyString).hashCode = function () {
    return getStringHashCode(this.u27_1);
  };
  protoOf(AnyString).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AnyString))
      return false;
    var tmp0_other_with_cast = other instanceof AnyString ? other : THROW_CCE();
    if (!(this.u27_1 === tmp0_other_with_cast.u27_1))
      return false;
    return true;
  };
  function toJson$lambda(it) {
    return it.a27();
  }
  function _serializable$factory() {
    return getPropertyCallableRef('_serializable', 1, KProperty1, function (receiver) {
      return _get__serializable__azf9o3(receiver);
    }, null);
  }
  function unwrapOptionalString(_this__u8e3s4, key) {
    var value = _this__u8e3s4.n2(key);
    var tmp;
    if (value == null || equals(value, JsonNull_getInstance())) {
      tmp = null;
    } else {
      if (value instanceof JsonPrimitive) {
        var tmp_0;
        if (value.d1b()) {
          tmp_0 = value.e1b();
        } else {
          throwDeserializationError('Expected value of "' + key + '" to be a String but was ' + value.toString());
        }
        tmp = tmp_0;
      } else {
        throwDeserializationError('Expected value of "' + key + '" to be a String but was ' + toString_0(value));
      }
    }
    return tmp;
  }
  function unwrapString(_this__u8e3s4, key) {
    var value = _this__u8e3s4.n2(key);
    var tmp;
    if (value instanceof JsonPrimitive) {
      tmp = value.d1b();
    } else {
      tmp = false;
    }
    if (tmp)
      return value.e1b();
    throwDeserializationError('Expected value of "' + key + '" to be a String but was ' + toString_0(value));
  }
  function unwrapOptionalJsonDictionary(_this__u8e3s4, key) {
    var value = _this__u8e3s4.n2(key);
    var tmp;
    if (value == null || equals(value, JsonNull_getInstance())) {
      tmp = null;
    } else {
      if (value instanceof JsonObject) {
        tmp = Companion_instance_0.d27(value);
      } else {
        throwDeserializationError('Expected value of "' + key + '" to be an object but was ' + toString_0(value));
      }
    }
    return tmp;
  }
  function unwrapOptionalStringList(_this__u8e3s4, key) {
    var value = _this__u8e3s4.n2(key);
    var tmp;
    if (value == null || equals(value, JsonNull_getInstance())) {
      tmp = null;
    } else {
      if (value instanceof JsonArray) {
        var tmp_0 = asSequence(value);
        tmp = toList_0(map(tmp_0, unwrapOptionalStringList$lambda));
      } else {
        throwDeserializationError('Expected array but was ' + toString_0(value));
      }
    }
    return tmp;
  }
  function unwrapOptionalMultiValueString(_this__u8e3s4, key) {
    var value = _this__u8e3s4.n2(key);
    var tmp;
    if (value == null || equals(value, JsonNull_getInstance())) {
      tmp = null;
    } else {
      if (value instanceof JsonPrimitive) {
        var tmp_0;
        if (value.d1b()) {
          tmp_0 = DefaultJsonMultiValue_init_$Create$(value.e1b());
        } else {
          throwDeserializationError('Expected value of "' + key + '" to contain string or string[], but was ' + value.toString());
        }
        tmp = tmp_0;
      } else {
        if (value instanceof JsonArray) {
          // Inline function 'kotlin.collections.mapIndexed' call
          // Inline function 'kotlin.collections.mapIndexedTo' call
          var destination = ArrayList_init_$Create$(collectionSizeOrDefault(value, 10));
          var index = 0;
          var tmp0_iterator = value.j();
          while (tmp0_iterator.k()) {
            var item = tmp0_iterator.l();
            // Inline function 'io.curity.ssi.json.data.unwrapOptionalMultiValueString.<anonymous>' call
            var tmp1 = index;
            index = tmp1 + 1 | 0;
            var index_0 = checkIndexOverflow(tmp1);
            var tmp_1;
            var tmp_2;
            if (item instanceof JsonPrimitive) {
              tmp_2 = item.d1b();
            } else {
              tmp_2 = false;
            }
            if (tmp_2) {
              tmp_1 = item.e1b();
            } else {
              throwDeserializationError('Expected value of "' + key + '" to contain only objects but at [' + index_0 + '] was ' + value.toString());
            }
            var tmp$ret$0 = tmp_1;
            destination.e(tmp$ret$0);
          }
          tmp = DefaultJsonMultiValue_init_$Create$_0(destination);
        } else {
          throwDeserializationError('Expected value of "' + key + '" to be an object but was ' + toString_0(value));
        }
      }
    }
    return tmp;
  }
  function unwrapOptionalLong(_this__u8e3s4, key) {
    var value = _this__u8e3s4.n2(key);
    var tmp;
    if (value == null || equals(value, JsonNull_getInstance())) {
      tmp = null;
    } else {
      if (value instanceof JsonPrimitive) {
        var tmp0_elvis_lhs = get_longOrNull(value);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          throwDeserializationError('Expected value of "' + key + '" to be a Number but was ' + value.toString());
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp = tmp_0;
      } else {
        throwDeserializationError('Expected value of "' + key + '" to be a Number but was ' + toString_0(value));
      }
    }
    return tmp;
  }
  function unwrapJsonDictionary(_this__u8e3s4, key) {
    var value = _this__u8e3s4.n2(key);
    var tmp;
    if (value == null || equals(value, JsonNull_getInstance())) {
      tmp = null;
    } else {
      if (value instanceof JsonObject) {
        tmp = Companion_instance_0.d27(value);
      } else {
        throwDeserializationError('Expected value of "' + key + '" to be an object but was ' + toString_0(value));
      }
    }
    return tmp;
  }
  function unwrapStringSet(_this__u8e3s4, key) {
    var value = _this__u8e3s4.n2(key);
    if (value instanceof JsonArray) {
      var tmp = asSequence(value);
      return toSet(map(tmp, unwrapStringSet$lambda));
    }
    throwDeserializationError('Expected value of "' + key + '" to be an array but was ' + toString_0(value));
  }
  function unwrapStringList(_this__u8e3s4, key) {
    var value = _this__u8e3s4.n2(key);
    if (value instanceof JsonArray) {
      var tmp = asSequence(value);
      return toList_0(map(tmp, unwrapStringList$lambda));
    }
    throwDeserializationError('Expected value of "' + key + '" to be an array but was ' + toString_0(value));
  }
  function unwrapMultiValueJsonDictionary(_this__u8e3s4, key) {
    var value = _this__u8e3s4.n2(key);
    var tmp;
    if (value instanceof JsonObject) {
      tmp = DefaultJsonMultiValue_init_$Create$(Companion_instance_0.d27(value));
    } else {
      if (value instanceof JsonArray) {
        // Inline function 'kotlin.collections.mapIndexed' call
        // Inline function 'kotlin.collections.mapIndexedTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(value, 10));
        var index = 0;
        var tmp0_iterator = value.j();
        while (tmp0_iterator.k()) {
          var item = tmp0_iterator.l();
          // Inline function 'io.curity.ssi.json.data.unwrapMultiValueJsonDictionary.<anonymous>' call
          var tmp1 = index;
          index = tmp1 + 1 | 0;
          var index_0 = checkIndexOverflow(tmp1);
          var tmp_0;
          if (item instanceof JsonObject) {
            tmp_0 = Companion_instance_0.d27(item);
          } else {
            throwDeserializationError('Expected value of "' + key + '" to contain only objects but at [' + index_0 + '] was ' + value.toString());
          }
          var tmp$ret$0 = tmp_0;
          destination.e(tmp$ret$0);
        }
        tmp = DefaultJsonMultiValue_init_$Create$_0(destination);
      } else {
        throwDeserializationError('Expected value of "' + key + '" to be an object but was ' + toString_0(value));
      }
    }
    return tmp;
  }
  function unwrapOptionalBoolean(_this__u8e3s4, key) {
    var value = _this__u8e3s4.n2(key);
    var tmp;
    if (value == null || equals(value, JsonNull_getInstance())) {
      tmp = null;
    } else {
      if (value instanceof JsonPrimitive) {
        var tmp0_elvis_lhs = get_booleanOrNull(value);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          throwDeserializationError('Expected value of "' + key + '" to be a Boolean but was ' + value.toString());
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp = tmp_0;
      } else {
        throwDeserializationError('Expected value of "' + key + '" to be a String but was ' + toString_0(value));
      }
    }
    return tmp;
  }
  function throwDeserializationError(message) {
    throw IllegalArgumentException_init_$Create$(message);
  }
  function unwrapOptionalStringInstant(_this__u8e3s4, key) {
    var tmp0_elvis_lhs = unwrapOptionalString(_this__u8e3s4, key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var string = tmp;
    var tmp_0;
    try {
      tmp_0 = Companion_getInstance().a1m(string);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Exception) {
        var e = $p;
        throwDeserializationError('Expected value of "' + key + '" to be a String Instant but it could not be parsed: ' + e.toString());
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    return tmp_0;
  }
  function unwrapOptionalStringList$lambda(it) {
    var tmp;
    var tmp_0;
    if (it instanceof JsonPrimitive) {
      tmp_0 = it.d1b();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = it.e1b();
    } else {
      throwDeserializationError('Expected array item to be a String but was ' + toString(it));
    }
    return tmp;
  }
  function unwrapStringSet$lambda(it) {
    var tmp;
    var tmp_0;
    if (it instanceof JsonPrimitive) {
      tmp_0 = it.d1b();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = it.e1b();
    } else {
      throwDeserializationError('Expected array item to be a String but was ' + toString(it));
    }
    return tmp;
  }
  function unwrapStringList$lambda(it) {
    var tmp;
    var tmp_0;
    if (it instanceof JsonPrimitive) {
      tmp_0 = it.d1b();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = it.e1b();
    } else {
      throwDeserializationError('Expected array item to be a String but was ' + toString(it));
    }
    return tmp;
  }
  function JsonSerializer(_fromJson) {
    this.v27_1 = _fromJson;
    this.w27_1 = Companion_instance.b1b();
    this.x27_1 = this.w27_1.yn();
  }
  protoOf(JsonSerializer).yn = function () {
    return this.x27_1;
  };
  protoOf(JsonSerializer).y27 = function (encoder, value) {
    encoder.ct(this.w27_1, value.a27());
  };
  protoOf(JsonSerializer).zn = function (encoder, value) {
    return this.y27(encoder, (!(value == null) ? isInterface(value, ToJson) : false) ? value : THROW_CCE());
  };
  protoOf(JsonSerializer).ao = function (decoder) {
    return this.v27_1.d27(decoder.kr(this.w27_1));
  };
  function ToJsonDictionarySerializer$_init_$lambda_aby31c(toJson) {
    return toJson.y26();
  }
  function ToJsonDictionarySerializer() {
    ToJsonDictionarySerializer_instance = this;
    var tmp = JsonDictionarySerializer_getInstance();
    DelegateSerializer.call(this, tmp, ToJsonDictionarySerializer$_init_$lambda_aby31c);
  }
  var ToJsonDictionarySerializer_instance;
  function ToJsonDictionarySerializer_getInstance() {
    if (ToJsonDictionarySerializer_instance == null)
      new ToJsonDictionarySerializer();
    return ToJsonDictionarySerializer_instance;
  }
  function DerivedSerializer(_delegate, toSerializable, fromSerializable) {
    this.z27_1 = _delegate;
    this.a28_1 = toSerializable;
    this.b28_1 = fromSerializable;
    this.c28_1 = this.z27_1.yn();
  }
  protoOf(DerivedSerializer).yn = function () {
    return this.c28_1;
  };
  protoOf(DerivedSerializer).d28 = function (encoder, value) {
    return encoder.ct(this.z27_1, this.a28_1(value));
  };
  protoOf(DerivedSerializer).zn = function (encoder, value) {
    return this.d28(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(DerivedSerializer).ao = function (decoder) {
    return this.b28_1(decoder.kr(this.z27_1));
  };
  function getStringOrDefault(_this__u8e3s4, key, defaultValue) {
    defaultValue = defaultValue === VOID ? '' : defaultValue;
    var value = _this__u8e3s4.vl(key);
    var tmp;
    var tmp_0;
    if (value instanceof JsonPrimitive) {
      tmp_0 = value.d1b();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = value.e1b();
    } else {
      tmp = defaultValue;
    }
    return tmp;
  }
  function identity$ref() {
    var l = function (p0) {
      return identity(p0);
    };
    l.callableName = 'identity';
    return l;
  }
  function DelegateSerializer(delegate, converter) {
    DerivedSerializer.call(this, delegate, converter, identity$ref());
  }
  function JsonDictionarySerializer() {
    JsonDictionarySerializer_instance = this;
    this.e28_1 = MapSerializer(serializer(StringCompanionObject_instance), Companion_instance.b1b());
    this.f28_1 = this.e28_1.yn();
  }
  protoOf(JsonDictionarySerializer).yn = function () {
    return this.f28_1;
  };
  protoOf(JsonDictionarySerializer).g28 = function (encoder, value) {
    encoder.ct(this.e28_1, value.xl());
  };
  protoOf(JsonDictionarySerializer).zn = function (encoder, value) {
    return this.g28(encoder, value instanceof JsonDictionary ? value : THROW_CCE());
  };
  protoOf(JsonDictionarySerializer).ao = function (decoder) {
    var map = decoder.kr(this.e28_1);
    return new JsonDictionary(map);
  };
  var JsonDictionarySerializer_instance;
  function JsonDictionarySerializer_getInstance() {
    if (JsonDictionarySerializer_instance == null)
      new JsonDictionarySerializer();
    return JsonDictionarySerializer_instance;
  }
  function DefaultJsonMultiValueSerializer$serialize$lambda(it) {
    var tmp;
    if (it instanceof JsonElement) {
      tmp = it;
    } else {
      if (!(it == null) ? isInterface(it, ToJson) : false) {
        tmp = it.a27();
      } else {
        // Inline function 'kotlinx.serialization.json.encodeToJsonElement' call
        var this_0 = Default_getInstance();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.dp();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_0(this_1, createKType(PrimitiveClasses_getInstance().wa(), arrayOf([]), true));
        var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
        tmp = this_0.a19(tmp$ret$1, it);
      }
    }
    return tmp;
  }
  function DefaultJsonMultiValueSerializer() {
    DefaultJsonMultiValueSerializer_instance = this;
    this.h28_1 = Companion_instance.b1b();
    this.i28_1 = this.h28_1.yn();
  }
  protoOf(DefaultJsonMultiValueSerializer).yn = function () {
    return this.i28_1;
  };
  protoOf(DefaultJsonMultiValueSerializer).j28 = function (encoder, value) {
    encoder.ct(this.h28_1, value.l27(DefaultJsonMultiValueSerializer$serialize$lambda));
  };
  protoOf(DefaultJsonMultiValueSerializer).zn = function (encoder, value) {
    return this.j28(encoder, value instanceof DefaultJsonMultiValue ? value : THROW_CCE());
  };
  protoOf(DefaultJsonMultiValueSerializer).ao = function (decoder) {
    var result = this.h28_1.ao(decoder);
    if (result instanceof JsonArray) {
      return DefaultJsonMultiValue_init_$Create$_0(toList(result));
    }
    return DefaultJsonMultiValue_init_$Create$(result);
  };
  var DefaultJsonMultiValueSerializer_instance;
  function DefaultJsonMultiValueSerializer_getInstance() {
    if (DefaultJsonMultiValueSerializer_instance == null)
      new DefaultJsonMultiValueSerializer();
    return DefaultJsonMultiValueSerializer_instance;
  }
  function identity(t) {
    return t;
  }
  function AnyStringSerializer() {
    AnyStringSerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_2);
  }
  var AnyStringSerializer_instance;
  function AnyStringSerializer_getInstance() {
    if (AnyStringSerializer_instance == null)
      new AnyStringSerializer();
    return AnyStringSerializer_instance;
  }
  function JsToJsonConverter() {
  }
  protoOf(JsToJsonConverter).k28 = function (value) {
    if (value == null)
      return JsonNull_getInstance();
    var tmp;
    if (!(value == null) ? typeof value === 'string' : false) {
      tmp = JsonPrimitive_0(value);
    } else {
      if (!(value == null) ? typeof value === 'boolean' : false) {
        tmp = JsonPrimitive_2(value);
      } else {
        if (isNumber(value)) {
          tmp = JsonPrimitive_1(value);
        } else {
          var tmp_0;
          if (Array.isArray(value)) {
            var jsArray = value;
            var result = ArrayList_init_$Create$_0();
            var _iterator__ex2g4s = iterator(jsArray);
            while (_iterator__ex2g4s.k()) {
              var item = _iterator__ex2g4s.l();
              result.e(this.k28(item));
            }
            return new JsonArray(result);
          } else if (typeof value === 'object') {
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp_0 = this.l28(value);
          } else {
            throw IllegalArgumentException_init_$Create$('Cannot convert JS Value to JsonElement: ' + toString_0(value));
          }
          tmp = tmp_0;
        }
      }
    }
    return tmp;
  };
  protoOf(JsToJsonConverter).l28 = function (jsObject) {
    var keys = Object.keys(jsObject);
    // Inline function 'kotlin.collections.mutableMapOf' call
    var result = LinkedHashMap_init_$Create$();
    var _iterator__ex2g4s = iterator(keys);
    while (_iterator__ex2g4s.k()) {
      var key = _iterator__ex2g4s.l();
      if (typeof key === 'string') {
        // Inline function 'kotlin.collections.set' call
        var value = this.k28(jsObject[key]);
        result.m2(key, value);
      } else {
        throw IllegalArgumentException_init_$Create$("Cannot convert JS object to JsonElement: non-string key: '" + toString(key) + "'");
      }
    }
    return new JsonObject(result);
  };
  var JsToJsonConverter_instance;
  function JsToJsonConverter_getInstance() {
    return JsToJsonConverter_instance;
  }
  function JsonToJsConverter() {
  }
  protoOf(JsonToJsConverter).m28 = function (value) {
    var tmp;
    if (equals(value, JsonNull_getInstance())) {
      tmp = null;
    } else {
      if (value instanceof JsonObject) {
        var result = {};
        var _iterator__ex2g4s = value.z().j();
        while (_iterator__ex2g4s.k()) {
          var _destruct__k2r9zo = _iterator__ex2g4s.l();
          // Inline function 'kotlin.collections.component1' call
          var name = _destruct__k2r9zo.a1();
          // Inline function 'kotlin.collections.component2' call
          var item = _destruct__k2r9zo.b1();
          result[name] = this.m28(item);
        }
        return result;
      } else {
        if (value instanceof JsonArray) {
          var result_0 = [];
          var _iterator__ex2g4s_0 = value.j();
          while (_iterator__ex2g4s_0.k()) {
            var item_0 = _iterator__ex2g4s_0.l();
            result_0.push(this.m28(item_0));
          }
          return result_0;
        } else {
          if (value instanceof JsonPrimitive) {
            var tmp_0;
            if (value.d1b()) {
              tmp_0 = value.e1b();
            } else {
              var tmp0_elvis_lhs = get_booleanOrNull(value);
              var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? get_intOrNull(value) : tmp0_elvis_lhs;
              var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? get_floatOrNull(value) : tmp1_elvis_lhs;
              tmp_0 = tmp2_elvis_lhs == null ? get_doubleOrNull(value) : tmp2_elvis_lhs;
            }
            tmp = tmp_0;
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
    return tmp;
  };
  protoOf(JsonToJsConverter).n28 = function (map) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.m28(new JsonObject(map));
  };
  var JsonToJsConverter_instance;
  function JsonToJsConverter_getInstance() {
    return JsonToJsConverter_instance;
  }
  //region block: post-declaration
  protoOf(JsonDictionary).a27 = toJson;
  protoOf(DefaultJsonMultiValue).qm = get_all;
  protoOf(DefaultJsonMultiValue).sm = isSingleItem;
  protoOf(DefaultJsonMultiValue).rm = forEach;
  protoOf(TypedJsonDictionary).f2 = get_keys;
  protoOf(TypedJsonDictionary).vl = get;
  protoOf(TypedJsonDictionary).a27 = toJson;
  protoOf(TypedJsonDictionary).xl = toMap_0;
  //endregion
  //region block: init
  FromJsonHelper_instance = new FromJsonHelper();
  Companion_instance_0 = new Companion();
  Companion_instance_1 = new Companion_0();
  Companion_instance_2 = new Companion_1();
  JsToJsonConverter_instance = new JsToJsonConverter();
  JsonToJsConverter_instance = new JsonToJsConverter();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = DefaultJsonMultiValue_init_$Create$_0;
  _.$_$.b = DefaultJsonMultiValue_init_$Create$;
  _.$_$.c = JsToJsonConverter_instance;
  _.$_$.d = JsonToJsConverter_instance;
  _.$_$.e = Companion_instance_1;
  _.$_$.f = DefaultJsonMultiValueSerializer_getInstance;
  _.$_$.g = FromJsonHelper_instance;
  _.$_$.h = Companion_instance_0;
  _.$_$.i = ToJsonDictionarySerializer_getInstance;
  _.$_$.j = AnyString;
  _.$_$.k = CompositeFromJson;
  _.$_$.l = DefaultJsonMultiValue;
  _.$_$.m = DelegateSerializer;
  _.$_$.n = DerivedSerializer;
  _.$_$.o = JsonDictionary;
  _.$_$.p = JsonSerializer;
  _.$_$.q = get;
  _.$_$.r = get_keys;
  _.$_$.s = toJson;
  _.$_$.t = ToJsonDictionary;
  _.$_$.u = ToJson;
  _.$_$.v = TypedDictionaryFromJson;
  _.$_$.w = getStringOrDefault;
  _.$_$.x = toJsons;
  _.$_$.y = toJson_4;
  _.$_$.z = toJson_1;
  _.$_$.a1 = toJson_2;
  _.$_$.b1 = toJson_3;
  _.$_$.c1 = toJson_0;
  _.$_$.d1 = toJson_5;
  _.$_$.e1 = unwrapJsonDictionary;
  _.$_$.f1 = unwrapMultiValueJsonDictionary;
  _.$_$.g1 = unwrapOptionalBoolean;
  _.$_$.h1 = unwrapOptionalJsonDictionary;
  _.$_$.i1 = unwrapOptionalLong;
  _.$_$.j1 = unwrapOptionalMultiValueString;
  _.$_$.k1 = unwrapOptionalStringInstant;
  _.$_$.l1 = unwrapOptionalStringList;
  _.$_$.m1 = unwrapOptionalString;
  _.$_$.n1 = unwrapStringList;
  _.$_$.o1 = unwrapStringSet;
  _.$_$.p1 = unwrapString;
  //endregion
  return _;
}));

//# sourceMappingURL=curity-ssi-libs-core-json.js.map
